import { DialogContent, DialogActions, TextField, Button, Box } from '@mui/material'

interface CreateStatusFormProps {
  statusInput: string
  onStatusInputChange: (value: string) => void
  onSubmit: (e: React.FormEvent) => void
  onClose: () => void
  isLoading: boolean
  error: string | null
  smbId: string
}

export const CreateStatusForm: React.FC<CreateStatusFormProps> = ({
  statusInput,
  onStatusInputChange,
  onSubmit,
  onClose,
  isLoading,
  error,
  smbId,
}) => {
  const handleFormSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    e.stopPropagation()
    if (!isLoading && statusInput.trim() && smbId && !error) {
      onSubmit(e)
    }
  }

  return (
    <Box
      style={{
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        overflow: 'hidden',
        width: '100%',
        boxSizing: 'border-box',
      }}
    >
      <DialogContent
        sx={{
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
          flex: 1,
          gap: 1.5,
          pt: 2.5,
          pb: 1,
          px: 3,
          width: '100%',
          boxSizing: 'border-box',
        }}
      >
        <TextField
          fullWidth
          label="New Status"
          value={statusInput}
          onChange={(e) => onStatusInputChange(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              handleFormSubmit(e)
            }
          }}
          autoFocus
          placeholder="e.g., Proposal Sent, Demo Completed"
          error={Boolean(error)}
          helperText={
            error
              ? error
              : statusInput.length >= 25
              ? 'Status cannot exceed 25 characters.'
              : 'Create a new status to track lead progress'
          }
          inputProps={{ maxLength: 25 }}
          FormHelperTextProps={{
            sx: {
              margin: '6px 0 0 !important',
              fontSize: '0.75rem',
              color: error
                ? 'error.main'
                : statusInput.length >= 25
                ? 'warning.main'
                : 'text.secondary',
            },
          }}
          sx={{
            flexShrink: 0,
            '& .MuiOutlinedInput-root': {
              borderRadius: '8px',
            },
          }}
        />
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2.5, pt: 0, flexShrink: 0 }}>
        <Button onClick={onClose} disabled={isLoading}>
          Cancel
        </Button>
        <Button
          type="button"
          onClick={handleFormSubmit}
          variant="contained"
          disabled={isLoading || !statusInput.trim() || !smbId || Boolean(error)}
        >
          {isLoading ? 'Creating...' : 'Create'}
        </Button>
      </DialogActions>
    </Box>
  )
}
